import {FormikProps} from 'formik';
import {useState} from 'react';
import ImageCropper from '../../../../../components/ImageCropper';
import {ShowFormError} from '../../../../../utilities/helper/showFormError';
import {IconNameInfoCircle} from '../../step1-validation/status1/GetNationalCardIdBottomSheet';
import UploadInfoBottomSheet from '../components/UploadInfoBottomSheet';
import {IDirectDocsForm} from './formDetails';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const InvoiceField = ({form}: IProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [secondPreviewUrl, setSecondPreviewUrl] = useState<string | null>(null);
  const [isOpenInfoBottomSheet, setIsOpenInfoBottomSheet] =
    useState<boolean>(false);
  const [showSecondImageUploader, setShowSecondImageUploader] =
    useState<boolean>(false);

  const handleFirstCropComplete = (croppedImage: File) => {
    form?.setFieldValue('invoiceFile', croppedImage);

    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result as string);
      setShowSecondImageUploader(true);
    };
    fileReader.readAsDataURL(croppedImage);
  };

  const handleRemoveImage = () => {
    setPreviewUrl(null);
    if (form) {
      form.setFieldValue('invoiceFile', null);
    }
  };

  // Second invoice handlers
  const handleSecondCropComplete = (croppedImage: File) => {
    form?.setFieldValue('secondInvoiceFile', croppedImage);

    const fileReader = new FileReader();
    fileReader.onload = () => {
      setSecondPreviewUrl(fileReader.result as string);
    };
    fileReader.readAsDataURL(croppedImage);
  };

  const handleRemoveSecondImage = () => {
    setSecondPreviewUrl(null);
    if (form) {
      form.setFieldValue('secondInvoiceFile', null);
    }
  };

  return (
    <div className="mt-3 mb-2">
      <p
        className="mb-3 font-medium color-gray-1 text-md"
        onClick={() => {
          setIsOpenInfoBottomSheet(true);
        }}
      >
        بارگذاری تصویر پیش پرداخت/ تاییدیه شغل کشاورزی
        <span className="text-red-500">*</span>
        <IconNameInfoCircle
          className="inline-block mr-2 text-center text-blue-600 size-4"
          fill="#2563eb"
        />
      </p>

      <div className="flex flex-col">
        <div className="flex gap-[1rem]">
          <div className="flex">
            {previewUrl ? (
              <div className="relative mb-3">
                <img
                  src={previewUrl}
                  alt="Invoice Image Preview"
                  className="w-20 h-20 object-contain rounded-xl border-[2px] border-dashed"
                />
                <i
                  className="absolute left-0 flex items-center justify-center w-6 h-6 text-xl text-red-600 cursor-pointer top-1 icon-nameDelete"
                  onClick={handleRemoveImage}
                />
              </div>
            ) : (
              <ImageCropper onCropComplete={handleFirstCropComplete} />
            )}
          </div>
          {/* Reveal Second Image UploadBox when the first is true */}
          {showSecondImageUploader && (
            <div className="flex">
              {secondPreviewUrl ? (
                <div className="relative mb-3">
                  <img
                    src={secondPreviewUrl}
                    alt="Invoice Image Preview"
                    className="w-20 h-20 object-contain rounded-xl border-[2px] border-dashed"
                  />
                  <i
                    className="absolute left-0 flex items-center justify-center w-6 h-6 text-xl text-red-600 cursor-pointer top-1 icon-nameDelete"
                    onClick={handleRemoveSecondImage}
                  />
                </div>
              ) : (
                <ImageCropper onCropComplete={handleSecondCropComplete} />
              )}
            </div>
          )}
        </div>

        <ShowFormError field="invoiceFile" form={form} />
        {previewUrl && <ShowFormError field="secondInvoiceFile" form={form} />}

        <UploadInfoBottomSheet
          open={isOpenInfoBottomSheet}
          setShouldOpen={setIsOpenInfoBottomSheet}
        />
      </div>
    </div>
  );
};

export default InvoiceField;
